module.exports = __webpack_public_path__ + "img/icon_flash_white.48898461.svg";